const SET_USUARIO = (state, obj) => {
  state.usuario = obj
}

export default {
  SET_USUARIO
}



// WEBPACK FOOTER //
// ./src/features/auth/store/mutations.js